module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[92]335.8f5f827.woff2";